import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "form-branch-container" }
const _hoisted_2 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    ($setup.props.payload.content.header)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(['card-title-container',$setup.isPC ? 'card-title' : 'card-title-h5'])
        }, _toDisplayString($setup.props.payload.content.header), 3))
      : _createCommentVNode("", true),
    ($setup.props.payload.status === 0 && $setup.canSelect)
      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList($setup.props.payload.content.items, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index,
            class: _normalizeClass(['form-branch-item', item.content ? '' : 'warning-item']),
            onClick: ($event: any) => ($setup.listItemClick(item))
          }, _toDisplayString(item.content || $setup.TUITranslateService.t('AIDesk.分支选项异常')), 11, _hoisted_2))
        }), 128))
      : _createCommentVNode("", true)
  ]))
}